import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    businessRequest: ['businessId'],
    businessAllRequest: ['options'],
    businessSummaryRequest: ['businessId'],
    businessCreateRequest: ['business'],
    businessUpdateRequest: ["businessId", 'business'],
    businessDeleteRequest: ['businessId'],
    businessCloseNotificationRequest: ['businessId'],
    updatePspBillRequest: ['businessId'],
    toggleReqsEnabledRequest: ['businessId'],
    toggleAllowDuplicatePhoneRequest: ['businessId'],
    createSignupReqsRequest: ['businessId', 'tagGroupIds'],
    fetchSignupReqsRequest: ['businessId'],
    deleteSignupReqRequest: ['businessId', 'signupReqId'],
    fetchSignupReqExclusionsRequest: ['businessId'],
    createSignupReqExclusionsRequest: ['businessId', 'planGroupIds'],
    deleteSignupReqExclusionRequest: ['businessId', 'exclusionId'],
    businessQrCodeRequest: ['businessId'],
    businessIndustriesRequest: ["industry"],

    businessSuccess: ['business'],
    businessAllSuccess: ['businesses'],
    businessSummarySuccess: ['businessSummary'],
    businessCreateSuccess: ['business'],
    businessUpdateSuccess: ['business'],
    businessCloseNotificationSuccess: ['business'],
    businessDeleteSuccess: [],
    businessQrCodeSuccess: ["qrCode"],
    updatePspBillSuccess: ["business"],
    toggleReqsEnabledSuccess: ["business"],
    toggleAllowDuplicatePhoneSuccess: ["business"],
    createSignupReqsSuccess: ["signupReqs"],
    fetchSignupReqsSuccess: ["signupReqs"],
    deleteSignupReqSuccess: ["signupReqs"],
    fetchSignupReqExclusionsSuccess: ["signupReqExclusions"],
    createSignupReqExclusionsSuccess: ["signupReqExclusions"],
    deleteSignupReqExclusionSuccess: ["signupReqExclusions"],
    businessIndustriesSuccess: ["industries"],

    businessFailure: ['error'],
    businessAllFailure: ['error'],
    businessSummaryFailure: ['error'],
    businessCreateFailure: ['error'],
    businessUpdateFailure: ['error'],
    businessDeleteFailure: ['error'],
    businessCloseNotificationFailure: ['error'],
    businessQrCodeFailure: ['error'],
    updatePspBillFailure: ['error'],
    toggleReqsEnabledFailure: ['error'],
    toggleAllowDuplicatePhoneFailure: ['error'],
    createSignupReqsFailure: ['error'],
    fetchSignupReqsFailure: ['error'],
    deleteSignupReqFailure: ['error'],
    fetchSignupReqExclusionsFailure: ['error'],
    createSignupReqExclusionsFailure: ['error'],
    deleteSignupReqExclusionFailure: ['error'],
    businessIndustriesFailure: ['error']
})

export const BusinessTypes = Types
export default Creators
